'use client';

import { styled } from '@linaria/react';
import { useQuery } from '@tanstack/react-query';
import { fetchPopTopic } from '@fe-news/actions/pop-topic';
import PopTopicGroupTags from '@fe-news/components/molecules/PopTopicCard/PopTopicGroupTags';
import PopTopicCardTitle from '@fe-news/components/molecules/PopTopicCard/PopTopicCardTitle';
import PopTopicCardContent from '@fe-news/components/molecules/PopTopicCard/PopTopicCardContent';
import PopTopicCardSkeleton from '@fe-news/components/molecules/PopTopicCardSkeleton';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

const PopTopicCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  border: 1px solid #e2e8f1;
  background-color: #fff;
  position: relative;
  min-height: auto;

  &:hover {
    box-shadow: 0 0 6px 0 rgba(0, 65, 143, 0.1);
  }
`;

type InfiniteCardProps = {
  id: string;
};

const InfiniteCard = ({ id }: InfiniteCardProps) => {
  const { data, isLoading } = useQuery({
    queryKey: ['my-pop-topic', `id:${id}`],
    queryFn: () => fetchPopTopic({ id: Number(id) })
  });

  const popTopicData = data?.data?.popularTopic;
  const relativeNews = data?.data?.data ?? [];

  const title = popTopicData?.title ?? '';
  const content = popTopicData?.content ?? '';
  const categories = popTopicData?.categories;
  const tags = new Set([...(popTopicData?.tagOr ?? []), ...(popTopicData?.tagAnd ?? [])].filter(tag => tag !== ''));

  const defaultImageId = relativeNews?.[0]?.newsId ?? 1;
  const defaultImage = `/assets/images/news_default_images/${defaultImageId % 10}.webp`;
  const bgImage = relativeNews?.[0]?.coverSrc?.l.src ?? defaultImage;

  if (isLoading) {
    return <PopTopicCardSkeleton />;
  }

  return (
    <PopTopicCardWrapper>
      {categories && <PopTopicGroupTags hotIssueTag={categories} />}
      <PopTopicCardTitle
        title={title}
        summary={content}
        tags={[...tags]}
        id={Number(id)}
        bgImage={bgImage}
        gtmEvent={{
          [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_POP,
          [GTMEventKey.SECTION]: 'News_Category_我的追蹤',
          [GTMEventKey.CLICK_ITEM]: `追蹤的時事＿${title}`
        }}
      />
      <PopTopicCardContent data={relativeNews} id={Number(id)} title={title} isMember />
    </PopTopicCardWrapper>
  );
};

export default InfiniteCard;
